<section class="main-section form-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/driversList/">Drivers</a></li>
      <li class="breadcrumb-item active" aria-current="page">Create Driver</li>
    </ol>
  </nav>
  <form>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black"> Driver Details</h2>
          <div class="row mt-3">
            <div class="col-md-12 col-md-8">
              <div class="row">
                <div class="col-md-3 required">
                  <div class="form-group">
                    <label class="control-label" for="firstName">Driver Name</label>
                    <input type="text" id="firstName" [(ngModel)]="driverName" [ngModelOptions]="{standalone: true}"
                           class="form-control" (blur)="typeDriverName()" [ngClass]="{'is-invalid':statusText1}"
                           onkeypress="return event.charCode >= 65 && event.charCode <= 90 || event.charCode >= 97 && event.charCode <= 122 || event.charCode == 32"
                           autocomplete="off" required>
                    <div id="statusText1" class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText1">
                      {{statusText1}}
                    </div>
                  </div>
                </div>
                <div class="col-md-3 required">
                  <div class="form-group ">
                    <label class="control-label" for="contactNumber">Phone Number</label>
                    <input type="text" id="contactNumber"
                           onkeypress='return event.charCode >= 48 && event.charCode <= 57' [(ngModel)]="mobileNumber"
                           [ngModelOptions]="{standalone: true}"
                           (blur)="validatePhone()" [ngClass]="{'is-invalid':statusText2}" maxlength="10"
                           class="form-control" required>
                    <div id="statusText2" class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText2">
                      {{statusText2}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3 required">
                  <div class="form-group ">
                    <label class="control-label" for="email">Email</label>
                    <input type="text" id="email" [(ngModel)]="email" [ngModelOptions]="{standalone: true}"
                           (blur)="validateEmaill()" [ngClass]="{'is-invalid':statusText3}" class="form-control"
                           required>
                    <div id="statusText3" class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText3">
                      {{statusText3}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black mb-3">Address</h2>
          <div class="row">
            <div class="col-md-4 required">
              <div class="form-group">
                <label class="control-label" for="addressType">AddressType</label>
                <select id="addressType" class="form-control" [(ngModel)]="address.addressType"
                        (blur)="selectAddressType()" [ngClass]="{'is-invalid':statusText4}"
                        [ngModelOptions]="{standalone: true}" required>
                  <option *ngFor="let a of addressTypes" [ngValue]="a.config">{{a.config}}</option>
                </select>
                <div id="statusText4" class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText4">
                  {{statusText4}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 required">
              <div class="form-group ">
                <label class="control-label" for="address1">Address 1</label>
                <input type="text" id="address1" [(ngModel)]="address.address1" class="form-control"
                       (blur)="typeAddress()" [ngClass]="{'is-invalid':statusText5}"
                       [ngModelOptions]="{standalone: true}" required>
                <div id="statusText5" class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText5">
                  {{statusText5}}
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="control-label" for="address2">Address 2</label>
                <input type="text" id="address2" [(ngModel)]="address.address2" class="form-control"
                       [ngModelOptions]="{standalone: true}" required>
              </div>
            </div>
            <div class="col-md-4 required">
              <div class="form-group ">
                <label class="control-label">City</label>
                <ng-select type="text" id="city" [(ngModel)]="address.city"
                           [ngModelOptions]="{standalone: true}" placeholder="City" [items]="citiesList" [addTag]="true"
                           (blur)="typeCity()" [ngClass]="{'is-invalid':statusText6}" required>
                </ng-select>
                <div id="statusText6" class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText6">
                  {{statusText6}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 required">
              <div class="form-group ">
                <label class="control-label">State</label>
                <ng-select id="State" [(ngModel)]="address.state" [ngModelOptions]="{standalone: true}"
                           [ngClass]="{'service-error':statusText7}"
                           (blur)="typeState()"
                           [ngClass]="{'is-invalid':statusText7}"
                           [items]="statesList"
                           placeholder="State">
                </ng-select>
                <div id="statusText7" class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText7">
                  {{statusText7}}
                </div>
              </div>
            </div>
            <div class="col-md-4 required">
              <div class="form-group ">
                <label class="control-label" for="accountZipAlt">Zip</label>
                <input type="text" id="accountZipAlt" onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                       maxlength="6" [(ngModel)]="address.zip" class="form-control" (change)="changeCityAndState()"
                       (blur)="zipCode()" [ngClass]="{'is-invalid':statusText8}" [ngModelOptions]="{standalone: true}"
                       required>
                <div id="statusText8" class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText8">
                  {{statusText8}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</section>
<div class="form-btn-section">
  <div class="row">
    <div class="col-12 text-right">
      <button type="reset" routerLink="/admin/driversList" id="cancel" class="btn btn-cancel">Cancel</button>
      <button type="submit" (click)="submitDriver()" id="save" class="btn btn-orange ml-2">Save</button>
    </div>
  </div>
</div>
